module.exports = "<div class=\"content-top clearfix\">\n  <h1 class=\"al-title\">{{ activePageTitle }}</h1>\n\n  <ul class=\"breadcrumb al-breadcrumb\">\n    <li class=\"breadcrumb-item\"><a routerLink=\"/pages/dashboard\">Home</a></li>\n    <li class=\"breadcrumb-item active\">{{ activePageTitle }}</li>\n  </ul>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baContentTop/baContentTop.html
// module id = 516
// module chunks = 16